<template>
  <el-col :span="24" id="period-manager" v-loading.body="receiving && !navigating" element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" class="padded-s" id="period-manager-header">
      <el-col :span="10" class="h-padded left-aligned-col">
        <div style="display: block;">
          <h2 style="margin: 0; font-weight: 100; display: inline-block;">PERIOD MANAGEMENT</h2>
          <p class="stats">{{ meta.count ? `${meta.count} results` : 'No results' }} </p>
          <p v-if="meta.count" class="stats">{{ meta.shown ? `${meta.shown} shown` : '' }}</p>
        </div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            @current-change="changePage"
            :current-page.sync="currentPage">
          </el-pagination>
        </el-row>
      </el-col>
      <el-col :span="10">
        <el-row type="flex" justify="end">
          <el-button plain @click="handleDialogVisible(true)">
            Close current period
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <el-table
          id="period-table"
          :data="periods"
          border
          style="width: 100%; z-index: 0;"
          :maxHeight="tableHeight"
          ref="periodTable">
          <el-table-column prop="start" label="Started"></el-table-column>
          <el-table-column prop="active" label="Status" width="100">
            <template slot-scope="scope">
              <el-row type="flex">
                <el-tag type="success" v-if="scope.row.active">
                  Active
                </el-tag>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="Close Period"
      size="large"
      :visible.sync="dialogFormVisible">
      <el-row type="flex" align="middle" justify="space-between" :gutter="20">
        <el-col :span="5" v-if="currentPeriod && Object.keys(currentPeriod).length">
          <el-row type="flex" align="middle" justify="start">
            <el-input
              ref="currPeriodStartInput"
              v-model="currentPeriod.start"
              :disabled="true">
              <template slot="prepend">Current Period Start Date</template>
            </el-input>
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row type="flex" align="middle" justify="start">
            <el-input
              ref="currPeriodEndInput"
              name="currPeriodEndInput"
              :value="form.end"
              @blur="(e) => handleBlur('end', e)"
              :disabled="fetchingQuote">
              <template slot="prepend">Current Period End Date</template>
            </el-input>
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row type="flex" align="middle" justify="start">
            <el-input
              ref="nextPeriodStartInput"
              name="nextPeriodStartInput"
              :value="form.start"
              @blur="(e) => handleBlur('start', e)"
              :disabled="fetchingQuote">
              <template slot="prepend">Next Period Start Date</template>
            </el-input>
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row type="flex" align="middle" justify="start">
            <el-tag v-if="!startDateIsValid && dateErrorMsg" type="danger">
              {{ dateErrorMsg }}
            </el-tag>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end" align="middle">
            <el-button type="danger" plain @click="handleDialogVisible(false)">
              Cancel
            </el-button>
            <el-button type="success" @click="submitForm" :loading="periodSaveStatus" :disabled="!(startDateIsValid && !fetchingQuote)">
              {{ periodSaveStatus ? 'Saving' : 'Save' }}
            </el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle">
        <el-col :span="24">
          <el-row type="flex" align="middle">
            <h3>Transactions to be moved into this period</h3>
          </el-row>
          <el-row type="flex" align="middle">
            <el-table
              v-loading="fetchingQuote"
              element-loading-text="Loading..."
              height="300"
              :data="presentableQuote && presentableQuote.moves ? presentableQuote.moves : []">
              <el-table-column prop="transactionType" label="Transaction Type"></el-table-column>
              <el-table-column prop="number" label="Number"></el-table-column>
              <el-table-column prop="description" label="Description"></el-table-column>
              <el-table-column prop="status" label="Status" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 'DRAFT'" type="primary" style="background-color: #fff; border-color: #04709d;">
                    {{ scope.row.status }}
                  </el-tag>
                  <el-tag v-if="['OPEN', 'AUDITED'].includes(scope.row.status)" type="primary">
                    {{ scope.row.status }}
                  </el-tag>
                  <el-tag v-if="['POSTED', 'CLOSED', 'VOIDED'].includes(scope.row.status)" type="gray">
                    {{ scope.row.status }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" style="margin-top: 12px;">
        <el-col :span="24">
          <el-row type="flex" align="middle">
            <h3>Transactions to be closed</h3>
          </el-row>
          <el-row type="flex" align="middle">
            <el-table
              v-loading="fetchingQuote"
              element-loading-text="Loading..."
              height="300"
              :data="presentableQuote && presentableQuote.closes ? presentableQuote.closes : []">
              <el-table-column prop="transactionType" label="Transaction Type"></el-table-column>
              <el-table-column prop="number" label="Number"></el-table-column>
              <el-table-column prop="description" label="Description"></el-table-column>
              <el-table-column prop="status" label="Status" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 'DRAFT'" type="primary" style="background-color: #fff; border-color: #04709d;">
                    {{ scope.row.status }}
                  </el-tag>
                  <el-tag v-if="['OPEN', 'AUDITED'].includes(scope.row.status)" type="primary">
                    {{ scope.row.status }}
                  </el-tag>
                  <el-tag v-if="['POSTED', 'CLOSED', 'VOIDED'].includes(scope.row.status)" type="gray">
                    {{ scope.row.status }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </el-col>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import { validate } from '@/utils/helpers/Validate'
  import { formatDateFields } from '@/utils/helpers/FormatDate'
  import store from '@/store/store'
  import moment from 'moment'
  import { DateFormatter } from '../../utils/helpers/FormatDate'

  export default {
    data () {
      return {
        tableHeight: 1000,
        currentPage: 1,
        dialogFormVisible: false,
        fields: [
          {
            name: 'start',
            label: 'Start Date',
            dataType: 'string',
            fieldType: 'date',
            required: true,
            msg: 'Please specify a date'
          }
        ],
        startDateChanged: false,
        endDateChanged: false,
        form: { start: '', end: '' },
        presentableQuote: {},
        startDateIsValid: true,
        newPeriodIsBeforePrevPeriod: false,
        dateErrorMsg: null,
        lastQuoteFetchTimestamp: ''
      }
    },
    methods: {
      handleDialogVisible (visibleState) {
        this.dialogFormVisible = visibleState
        if (visibleState) {
          this.getPeriodCloseData()
        } else {
          this.setInitialState()
        }
      },
      async getPeriodCloseData () {
        try {
          const response = await this.$store.dispatch('fetchPeriodsQuote')
          if (response) {
            return this.buildPresentableQuote()
          } else {
            notify(this, 'error', 'Error fetching period quote')
          }
        } catch (e) {
          console.log(e)
          return notify(this, 'error', e || 'Error fetching period quote')
        }
      },
      buildPresentableQuote () {
        const getOfType = (v) => {
          if (!(v && v.type && v.id)) return {}
          switch (v.type) {
            case 'journalentry':
              return this.getJeById(v.id)
            case 'accountspayable':
              return this.getApById(v.id)
            case 'accountsreceivable':
              return this.getArById(v.id)
            case 'billpayment':
              return this.getBpById(v.id)
            case 'prepayment':
              return this.getPpById(v.id)
            case 'purchaseorder':
              return this.getPoById(v.id)
            case 'pettycash':
              return this.getPcById(v.id)
            case 'papercheck':
              let check = this.getCheckById(v.id)
              check['transactionType'] = 'Check'
              return check
            case 'payment':
              let payment = this.getPaymentById(v.id)
              payment['transactionType'] = 'Payment'
              return payment
          }
        }
        let presentable = Object.assign({}, this.quote)
        const { closes, moves } = presentable
        if (closes) {
          presentable.closes = presentable.closes.map(v => getOfType(v))
        }
        if (moves) {
          presentable.moves = presentable.moves.map(v => getOfType(v))
        }
        this.presentableQuote = presentable
      },
      async submitForm () {
        let form = Object.assign({}, this.form)
        delete form.end
        let validationErrors = validate(form, this.fields)
        if (!validationErrors.messages) {
          try {
            const response = await this.$store.dispatch('savePeriod', form)
            if (response) {
              this.setInitialState()
              this.handleDialogVisible(false)
              await this.$store.dispatch('fetchPeriodsWithQuery')
              notify(this, 'success', 'Period successfully closed')
            } else {
              notify(this, 'error', this.periodSaveFailure || 'Error saving period')
            }
          } catch (e) {
            console.log(e)
            notify(this, 'error', this.periodSaveFailure || 'Error saving period')
          }
        } else {
          let offset = 0
          validationErrors.messages.map(v => {
            notify(this, 'warning', v, offset)
            offset += 100
          })
        }
      },
      handleBlur (dateType, e) {
        if (this.form[dateType] === e.target.value) { // if the value of the field is the same as e.target.value, then the field WAS blurred but NOT changed
          return
        }
        this.form[dateType] = e.target.value
        formatDateFields(this, dateType, false)
        this.$refs[e.target.name].currentValue = this.form[dateType]  // forcefully update ElementUI input field's "currentValue" prop because we're not using v-model
        if (dateType === 'start') {
          this.form.end = moment(this.form.start).subtract(1, 'day').format('YYYY-MM-DD')
        } else {
          this.form.start = moment(DateFormatter.formatISODateString(this.form.end)).add(1, 'day').format('YYYY-MM-DD')
        }
        if (!this.checkIfStartDateIsValid()) {
          this.$refs[e.target.name].currentValue = ''
          e.target.focus()
        }
      },
      checkIfStartDateIsValid () {
        const newPeriodSd = new Date(this.form.start)
        let currPeriodSd
        if (this.currentPeriod && Object.keys(this.currentPeriod).length) {
          currPeriodSd = new Date(this.currentPeriod.start)
        }
        this.newPeriodIsBeforePrevPeriod = currPeriodSd >= newPeriodSd
        if (this.form.start && this.form.start !== 'Invalid date' && !this.newPeriodIsBeforePrevPeriod) {
          this.startDateIsValid = true
          this.dateErrorMsg = ''
          return true
        } else if (this.form.start && this.form.start !== 'Invalid date' && this.newPeriodIsBeforePrevPeriod) {
          this.dateErrorMsg = "Start date cannot be on or before previous period's start date"
        } else {
          this.dateErrorMsg = 'Invalid date'
        }
        this.startDateIsValid = false
        this.form = Object.assign({}, { start: '', end: '' })
        return false
      },
      setInitialState () {
        if (this.currentStartDateIsInFuture) {
          this.form.end = moment(this.currentPeriod.start).endOf('month').format('YYYY-MM-DD')
          this.form.start = moment(this.form.end).add(1, 'day').format('YYYY-MM-DD')
        } else {
          this.form.end = moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
          this.form.start = moment(new Date()).format('YYYY-MM-DD')
        }
        this.newPeriodIsBeforePrevPeriod = false
        this.dateErrorMsg = null
        this.lastQuoteFetchTimestamp = ''
        this.startDateIsValid = true
      }
    },
    computed: {
      ...mapGetters({
        meta: 'getPeriodMetadata',
        quote: 'getPeriodsQuote',
        periods: 'getPeriods',
        receiving: 'getPeriodFetchStatus',
        currentPeriod: 'getCurrentPeriod',
        fetchingQuote: 'getPeriodsQuoteFetchStatus',
        fetchingQuoteError: 'getPeriodsQuoteFetchFailure',
        periodSaveStatus: 'getPeriodSaveStatus',
        periodSaveFailure: 'getPeriodSaveFailure',
        getJeById: 'getJeById',
        getApById: 'getApById',
        getArById: 'getArById',
        getBpById: 'getBpById',
        getPpById: 'getPpById',
        getPcById: 'getPcById',
        getPoById: 'getPoById',
        getCheckById: 'getCheckById',
        getPaymentById: 'getPaymentById',
        navigating: 'getNavigationStatus'
      }),
      currentStartDateIsInFuture () {
        return (this.currentPeriod && new Date(this.currentPeriod.start) > new Date())
      }
    },
    mounted () {
      this.$nextTick = () => {
        const tableHeight = () => {
          const parentHeight = document.getElementById('period-manager').offsetHeight
          const headerHeight = document.getElementById('period-manager-header').offsetHeight
          return parentHeight - headerHeight
        }
        this.tableHeight = tableHeight()
      }
    },
    created () {
      this.setInitialState()
      const { query } = this.$route
      if (query.hasOwnProperty('closeCurrent') && query.closeCurrent === 'true') {
        this.handleDialogVisible(true)
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        await store.dispatch('fetchPeriodsWithQuery')
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        const promises = [
          this.$store.dispatch('resetJeMeta'),
          this.$store.dispatch('clearJeState', true),
          this.$store.dispatch('resetApMeta'),
          this.$store.dispatch('clearApState', true),
          this.$store.dispatch('resetArMeta'),
          this.$store.dispatch('clearArState', true),
          this.$store.dispatch('resetBpMeta'),
          this.$store.dispatch('clearBpState', true),
          this.$store.dispatch('resetPpMeta'),
          this.$store.dispatch('clearPpState', true),
          this.$store.dispatch('resetPcMeta'),
          this.$store.dispatch('clearPcState', true),
          this.$store.dispatch('resetPoMeta'),
          this.$store.dispatch('clearPoState', true)
        ]
        await Promise.all(promises)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .padded-s {
    padding: 12px;
  }
  #period-manager-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .stats {
    margin: 0;
    display: inline-block;
    padding: 0 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Programs/PeriodManager.vue